module.exports = __webpack_public_path__ + "b8e58f2bb0ee4c37cd0815f0c20b025d.woff2";